/**
 * Home hero LCP optimization
 *
 * Keeps the existing image-lazy component intact, but ensures the hydrated
 * <img> for the visible hero image gets the loading hints PageSpeed expects.
 */

(function() {
  'use strict';

  function getHomeHeroSection() {
    return document.querySelector('.shopify-section--home-hero');
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function findTargetImage(section) {
    var target = isMobileViewport() ? 'mobile' : 'desktop';
    var targetImage = section.querySelector('[data-home-lcp-image="' + target + '"] img');

    if (targetImage) {
      return targetImage;
    }

    targetImage = section.querySelector('.hero__block-image--' + target + ' img');

    if (targetImage) {
      return targetImage;
    }

    return section.querySelector('.hero__block-image img');
  }

  function optimizeHomeHeroImage() {
    var section = getHomeHeroSection();

    if (!section) {
      return false;
    }

    var image = findTargetImage(section);

    if (!image) {
      return false;
    }

    image.setAttribute('fetchpriority', 'high');
    image.setAttribute('loading', 'eager');

    if (!image.hasAttribute('decoding')) {
      image.setAttribute('decoding', 'async');
    }

    return true;
  }

  function init() {
    if (optimizeHomeHeroImage()) {
      return;
    }

    var observer = new MutationObserver(function(mutations, obs) {
      if (optimizeHomeHeroImage()) {
        obs.disconnect();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    setTimeout(function() {
      observer.disconnect();
    }, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
